import { InputHTMLAttributes, useEffect, useRef } from 'react'
import Checkbox from '@mui/material/Checkbox'

export type CheckboxValue = boolean | 'indeterminate'

export default function CheckboxInput({
  checked,
  label,
  id,
  onChange
}: Readonly<{
  checked: CheckboxValue
  label: string
  id: string
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void
}> &
  Omit<InputHTMLAttributes<HTMLInputElement>, 'checked'>) {
  return (
    <div className='checkbox flex items-center gap-1'>
      <Checkbox
        id={id}
        indeterminate={checked === 'indeterminate'}
        checked={checked === true || checked === false ? checked : false}
        size='small'
        sx={{
          height: '18px',
          width: '18px'
        }}
        onChange={onChange}
      />
      <label
        htmlFor={id}
        onClick={e => {
          e.stopPropagation()
        }}
        className='cursor-pointer text-sm'
      >
        {label}
      </label>
    </div>
  )
}
